import cn from 'classnames'
import moment from 'moment'
import React from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { ISolutionListItemFragment } from 'src/graphql/generated/hooks'

export interface ConsolidationListItemProps {
  solution: ISolutionListItemFragment
  index: number
  href: string
}

export const ConsolidationListItem: React.FC<ConsolidationListItemProps> = ({ solution, index, href }) => {
  const mode = index % 2
  const bgClr = mode === 0 ? 'bg-white border-mist border-x' : 'bg-blueChalk'
  const listdate = solution?.consolidation?.date
  const formatedDate = listdate ? moment(listdate).format('MMM DD, YYYY') : null

  const hrefUrl = solution?.consolidation?.articleLink ? solution?.consolidation?.articleLink : ''

  const linkStyle = {
    cursor: hrefUrl ? 'pointer' : 'default !important',
    textDecoration: hrefUrl ? 'underline !important' : 'none !important',
  }

  return (
    <div className={cn('flex', 'flex-row', 'items-center', 'pt-[14px] pb-[8px]', bgClr)}>
      <div className="flex flex-row w-full items-center">
        {/* <CompatibleLink href={hrefUrl ? hrefUrl : ''} target="_blank"> */}
        <div className="flex flex-row w-full md:h-[79px] pl-[10px] pr-[10px]">
          <p className="flex h-full items-center font-primary text-[14px] leading-[17px] text-darkgray md:w-[105px] w-1/4 break-word">
            {formatedDate}
          </p>
          <p className="flex h-full items-center font-primary text-[14px] leading-[17px] text-darkgray ml-[10px] md:w-[115px] w-1/4 break-word">
            {solution?.consolidation?.buyer || ''}
          </p>
          <CompatibleLink href={href ? href : ''}>
            <div className="flex flex-col h-full font-primary text-[14px] leading-[17px] text-textdark ml-[10px] md:w-[185px] w-1/4 break-word justify-center">
              {solution?.consolidation?.originalTargetName ? (
                <>
                  <p className=" text-[#000]">
                    <span className="italic font-bold">{solution?.consolidation?.originalTargetName},</span>
                  </p>
                  <p className=" text-[#000]">now known as</p>
                </>
              ) : (
                ''
              )}
              <p className="underline underline-offset-1">{solution?.displayName}</p>
            </div>
          </CompatibleLink>
          <CompatibleLink href={hrefUrl ? hrefUrl : ''} target="_blank" style={linkStyle}>
            <p className="flex h-full items-center font-primary text-[14px] leading-[17px] text-textdark ml-[10px] md:w-[355px] w-1/4 break-word underline underline-offset-1">
              {solution?.consolidation?.article || ''}
            </p>
          </CompatibleLink>
        </div>
        {/* </CompatibleLink> */}
      </div>
    </div>
  )
}
